import estilosC from "./Contacto.module.css";
import GoogleMapComponent from "../components/GoogleMapComponent";
import ContactUs from "../components/ContactUs";
import tittleimg from "../assets/tittle_gold.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";

import { motion } from "framer-motion";

const ContactPage = () => {
    return (
        <div className={estilosC.fondo}>
            <div className={`container ${estilosC.contacto}`}>
                {/* Encuéntranos */}
                <section className={estilosC.encuentranos}>
                    <h2>Encuéntranos</h2>
                    <img src={tittleimg} className={estilosC.shape} alt="Decoración" />
                    <p>
                        Estamos aquí para brindarte el apoyo y la orientación que necesitas
                        en nuestros servicios de salón de recepciones.
                    </p>
                </section>

                <ContactUs />

                {/* Sección principal */}
                <section className="row mt-5">
                    {/* Texto con animación */}
                    <motion.div
                        className="col-md-5 mb-4"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: "easeOut" }}
                    >
                        <div className={estilosC.texto}>
                            <h2>Estamos Aquí para Ti</h2>
                            <p>
                                En Dentisan, creemos que una sonrisa saludable es el reflejo de
                                una vida plena. Nuestra clínica dental está comprometida con
                                brindarte una experiencia cálida, profesional y completamente
                                centrada en tu bienestar.
                                <br />
                                <br />
                                Tu tiempo y tu salud son valiosos para nosotros. En Dentisan no
                                solo cuidamos tu sonrisa, también cuidamos de ti.
                            </p>
                        </div>
                    </motion.div>

                    {/* Teléfono + WhatsApp con animación y icono */}
                    <motion.div
                        className="col-md-7"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3, duration: 1, ease: "easeOut" }}
                    >
                        <div className={estilosC.contactColumn}>
                            <div className={estilosC.telefonoBox}>
                                <h3 className={estilosC.telefonoLabel}>
                                    <FontAwesomeIcon icon={faPhone} style={{ marginRight: 8 }} />
                                    Agenda tu cita:
                                </h3>
                                <a href="tel:+512434129" className={estilosC.telefonoNumero}>
                                    (+51) 243 4129
                                </a>
                            </div>

                            <a
                                href="https://wa.me/51998664680"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={estilosC.whatsappButtonFull}
                            >
                                <FontAwesomeIcon
                                    icon={faWhatsapp}
                                    className={estilosC.whatsappIcon}
                                />
                                Agendar por WhatsApp
                            </a>
                        </div>
                    </motion.div>
                </section>
            </div>

            <GoogleMapComponent />

        </div>
    );
};

export default ContactPage;
